import { TranslateService } from '@ngx-translate/core';
import { Component, ElementRef, OnInit } from '@angular/core';
import {
  SelectedCustomerService,
  NavbarComponent,
  AuthService,
  CartService,
  SimpleRoute,
  AssortmentService,
  NavbarConfigService,
  NavGroup,
  GungFlowService,
  GlobalSearchConfigService
} from 'gung-standard';
import { takeUntil } from 'rxjs';
import { Router } from '@angular/router';

@Component({
    selector: 'cult-navbar',
    templateUrl: './cult-navbar.component.html',
    styleUrls: ['./cult-navbar.component.scss'],
    standalone: false
})
export class CultNavbarComponent extends NavbarComponent implements OnInit {
  email = 'order@hedlundgruppen.se';
  emailSubject = this.translateService.instant('CUSTOMER_SERVICE');
  subassortments: SimpleRoute[] = [];
  public secondlogoUrl = './assets/logotype-cult.png';
  constructor(
    protected selectedCustomerService: SelectedCustomerService,
    protected authService: AuthService,
    protected cartService: CartService,
    protected elementRef: ElementRef,
    protected translateService: TranslateService,
    private assortmentService: AssortmentService,
    protected navbarConfigService: NavbarConfigService,
    protected gungFlowService: GungFlowService,
    protected router: Router,
    protected globalSearchConfig: GlobalSearchConfigService
  ) {
    super(
      selectedCustomerService,
      authService,
      cartService,
      elementRef,
      navbarConfigService,
      gungFlowService,
      router,
      globalSearchConfig
    );

    this.authService
      .getIsAuthenticated()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(auth => {
        if (auth) {
          this.assortmentService
            .getUserAssortment()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe(assortment => {
              const subAssortments = assortment.children
                .filter(a => a.id && a.id.length > 0 && a.id[0] === 's')
                .map(a => {
                  return { route: '/categories/' + a.id, heading: a.name };
                });

              if (subAssortments && subAssortments.length !== 0) {
                subAssortments.forEach(subAssortment => this.subassortments.push(subAssortment));
              } else {
                subAssortments.push({ route: '/products', heading: 'SHOP_BY_PRODUCT_LIST' });
              }
            });
        }
      });
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  public toggleMobileMenu() {
    this.baseCollapseClasses.show = !this.baseCollapseClasses.show;
    this.isCollapsed = this.baseCollapseClasses.show;
  }

  /**
   * The left menu is collapsed into a dropdown on tablets and smaller, where it
   * has to be closed again once the click actually navigates somewhere. Entries
   * that only expand their sub menu keep the dropdown open.
   */
  public closeLeftMenuOnNavigation(leftMenuLink: NavGroup): void {
    if (!leftMenuLink.links || leftMenuLink.links.length === 0) {
      this.showLeftMenu = false;
    }
  }
}
